/* eslint-disable warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import { hash } from '@linc-technologies/linced-common/utils/promise';
import { service } from '@ember/service';

export default class LocationsRoute extends Route {
  // Services
  @service
  session;

  @service
  store;

  model() {
    return hash({
      locations: this.store.query('schools/location', {
        schoolId: this.session.activeSchool,
      }),
    });
  }
}
